module.exports = __webpack_public_path__ + "img/FR28033.5771f122.png";